export function uniqueSorted(values: (string | undefined | null)[]): string[] {
  const set = new Set(values.filter((v): v is string => Boolean(v && v.trim())).map((v) => v.trim()));
  return Array.from(set).sort((a, b) => a.localeCompare(b, 'pt-BR'));
}
